import Vue from 'vue';
import Vuex from 'vuex';

import login from './Modules/Login.js';
import adminPanel from './Modules/AdminPanel.js';

Vue.use(Vuex);

export const appStore = new Vuex.Store({
    state: {},
    modules: {
        login,
        adminPanel
    }
})


// WEBPACK FOOTER //
// ./src/Store/Store.js